import React, { useEffect, useState } from "react";

import Loading from "react-loading";

import ArrowDown from "../../assets/svg/arrow-down.svg";
import ArrowUp from "../../assets/svg/arrow-up.svg";
import { useLoadingProfileContext } from "../../pages/app/Profiles/profile-hook";
import { CheckBoxProfile } from "../CheckBoxProfile";
import { ExpandableLabel } from "../TreeCheckboxProfile";
import * as S from "./styles";

interface Actions {
  action: string;
  active: boolean;
  id: number;
  systemActionId: number;
  systemObjectUserCustomerProfileActionId: number | null;
}

interface DropdownOption {
  title: string;
  id: string;
  actionsList: Actions[];
  soUserCustomerProfileId?: string | number;
  userCustomerProfileId?: string | number;
  systemObjectCustomerId?: string | number;
}

interface IIdPair {
  optionId: string | number;
  actionId: string | number;
  soUserCustomerProfileId?: string | number;
  systemObjectUserCustomerProfileId?: string | number;
}

interface DropdownProps {
  title: string;
  options: DropdownOption[];
  onChange: (value: IIdPair) => void;
  loading: boolean;
  isOpen?: any;
  setIsOpen?: any;
  isCreateNewProfile: boolean;
  loadingUpdate: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  title,
  options,
  loading,
  onChange,
  isOpen,
  setIsOpen,
  isCreateNewProfile,
  loadingUpdate,
}) => {
  const [dataFormatted, setDataFormatted] = useState<any[]>([]);
  const { setLoadingProfile } = useLoadingProfileContext();
  const readActionId = 1;

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  function triggerActionClick(optionId: string | number, actionId: number) {
    const element = document.getElementById(
      `option-${optionId}-action-${actionId}`,
    );

    if (!element) {
      return;
    }

    setLoadingProfile(true);
    setTimeout(() => {
      element.click();
      setLoadingProfile(false);
    }, 300);
  }

  function ensureReadAction(option: DropdownOption, event: any) {
    if (event.actionId === readActionId || !event.active) {
      return;
    }

    const readAction = option?.actionsList?.find(
      (item: Actions) => item.systemActionId === readActionId,
    );

    if (!readAction || readAction.active) {
      return;
    }

    triggerActionClick(option.id, readActionId);
  }

  function handleCheckboxChange(option: DropdownOption, event: any) {
    onChange({
      ...event,
      systemObjectUserCustomerProfileId: option.soUserCustomerProfileId,
    });

    ensureReadAction(option, event);
  }

  function renderOptionActions(option: DropdownOption) {
    if (!option?.actionsList) {
      return null;
    }

    return option.actionsList.map((item: Actions, index: number) => (
      <CheckBoxProfile
        label={item.action}
        key={index}
        loadingUpdate={loadingUpdate}
        checked={item.active}
        systemActionId={item.systemActionId}
        soUserCustomerProfileId={option.soUserCustomerProfileId}
        style={
          title === "Ações"
            ? { marginLeft: "24px", marginTop: 4 }
            : { marginBottom: 10, marginTop: 10 }
        }
        userCustomerProfileId={option.userCustomerProfileId}
        id={option?.id}
        systemObjectCustomerId={option.systemObjectCustomerId}
        systemObjectUserCustomerProfileActionId={
          item.systemObjectUserCustomerProfileActionId
        }
        onChange={(event: any) => handleCheckboxChange(option, event)}
        isCreateNewProfile={isCreateNewProfile}
      />
    ));
  }

  function getActionList() {
    const titleToFilterBy = "Relatórios";

    if (title === titleToFilterBy) {
      const newOptions =
        options &&
        options.length &&
        options?.filter(
          (optionInList: any) => optionInList?.title === titleToFilterBy,
        );

      setDataFormatted(newOptions || []);
    } else {
      const newOptions =
        options &&
        options.length &&
        options?.filter(
          (optionInList: any) => optionInList?.title !== titleToFilterBy,
        );
      setDataFormatted(newOptions || []);
    }
  }

  useEffect(() => {
    getActionList();
  }, [options]);

  return (
    <S.DropdownContainer>
      <S.DropdownTitle onClick={handleDropdownClick}>
        {title}
        {isOpen !== undefined && (
          <S.DropdownIcon>
            {isOpen ? <img src={ArrowUp} /> : <img src={ArrowDown} />}
          </S.DropdownIcon>
        )}
      </S.DropdownTitle>

      {loading ? (
        <S.ContainerLoading>
          <Loading width={40} type="spin" color="#000" />
        </S.ContainerLoading>
      ) : (
        (isOpen === undefined || isOpen) && (
          <S.DropdownMenu>
            {title === "Ações" && <S.LabalContent></S.LabalContent>}
            {dataFormatted &&
              dataFormatted?.map((option, index) => (
                <S.DropdownOptionItem key={index}>
                  <ExpandableLabel title={option.title}>
                    {renderOptionActions(option)}
                  </ExpandableLabel>
                </S.DropdownOptionItem>
              ))}
          </S.DropdownMenu>
        )
      )}
    </S.DropdownContainer>
  );
};

export default Dropdown;
